import { render, staticRenderFns } from "./ModifyStock.vue?vue&type=template&id=6ad42e1a&scoped=true"
import script from "./ModifyStock.vue?vue&type=script&lang=js"
export * from "./ModifyStock.vue?vue&type=script&lang=js"
import style0 from "./ModifyStock.vue?vue&type=style&index=0&id=6ad42e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad42e1a",
  null
  
)

export default component.exports